import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gy-5 gx-xl-8" }
const _hoisted_2 = {
  class: "col-xxl-12",
  id: "kt_profile_details_view"
}
const _hoisted_3 = { class: "card mb-5 mb-xl-10 min-h-500px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeTable = _resolveComponent("TimeTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TimeTable, { teacherID: _ctx.teacherID }, null, 8, ["teacherID"])
      ])
    ])
  ]))
}